import { Box, Typography } from "@mui/material";
import SideBar from "../../components/sidebar";
import MainWrapper from "../../components/helpers/MainWrapper";
import RebrandingVideo from "../../videos/rebranding.mp4";
import VideoPlayer from "../../components/videoPlayer";

const Rebranding = () => {
  return (
    <Box
      sx={{
        width: "100vw",
        height: "100dvh",
      }}
    >
      <SideBar />
      <MainWrapper top={{ xs: "8rem", lg: "8rem", xl: "15rem" }}>
        <Box
          sx={{
            display: "flex",
            gap: "1rem",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h2"
            fontWeight="bold"
            color="#33636E"
            fontSize="1.8rem"
          >
            بیانیه ریبرندینگ
          </Typography>
        </Box>
        <Box
          sx={{
            objectFit: "contain",
            width: { xs: "90%", md: "100%" },
            height: { xs: "250px", md: "100%" },
          }}
        >
          <VideoPlayer src={RebrandingVideo} />
        </Box>
        <Typography
          sx={{
            fontSize: { xs: "12px", md: "14px" },
            color: "#2E2E2E",
            maxWidth: { xs: "90%", md: "100%" },
            textAlign: "justify",
          }}
        >
          پایداری زیست محیطی یعنی تعامل مسئولانه با کره زمین در جهت حفظ منابع
          طبیعی و جلوگیری از به خطر افتادن توانایی نـــسل های آینده برای برآوردن
          نیازهایشان. پایداری زیست ‌محیطی عبارت است از اقدام به ‌گونه‌ای که
          تضمین کند نسل‌های آینده منابع طبیعی را برای زندگی برابر، اگر نگوییم
          بهتر، مانند نسل‌های کنونی در اخـــــتیار داشته باشند. پایداری سنگ بنای
          ارزش ها و آرزوهای ماست. ما قویاً به نیاز مبرم به حفاظت و احیای محیط
          زیست خود برای نسل‌های فعلی و آینده اعتقاد داریم. پایداری یــک روند
          گذرا نیست، یک سبک زندگی است که قدرت تغییر دنیای ما را دارد. با پذیرش
          این سبک زندگی، جهانی را ترویج می‌کنیم که در آن انسان‌ و طبیعت بتوانند
          در کنار یکدیگر رشد کنند.
        </Typography>
      </MainWrapper>
    </Box>
  );
};

export default Rebranding;
